import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";

import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import ListItemText from "@material-ui/core/ListItemText";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import AddAlert from "@material-ui/icons/AddAlert";
import Tooltip from "@material-ui/core/Tooltip";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import CustomTable from "components/Table/CustomTable.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";

import httpr from "lib/httpRequest";
import Dialog from "@material-ui/core/Dialog";
import NumberFormat from "react-number-format";

const styles = (theme) => ({
  //const styles = {
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit + 100,
  },
  testContainer: {
    width: "100%",
  },
  addMemberControler: {
    marginLeft: theme.spacing.unit + 10,
    marginRight: theme.spacing.unit + 10,
  },
  checkBox: {
    marginLeft: 0,
    marginRight: 0,
    margin: 0,
    padding: 0,
    fontSize: "14px",
  },
  helperText: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  cardTitleBlack: {
    color: "#000000",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "200",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "0px",
    textDecoration: "none",
  },
  formControl: {
    margin: theme.spacing.unit,
    width: "99%",
  },
});

const ITEM_HEIGHT = 480;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class Profile extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      selectedLocIds: [],
      admin: null,
      emails: [],
      email: "",
      confirmEmail: "",
      emailLocation: 0,
      password: "",
      confirmPassword: "",
      firstName: "",
      lastName: "",
      emailErr: false,
      pwErr: false,
      fNameErr: false,
      lNameErr: false,
      locErr: false,
      mem: null,
      openPhone: false,
      openEmail: false,
      addPhoneErr: false,
      addEmailErr: false,
      addEmailLocErr: false,
      emailSnackbarOpen: false,
      emailSnackbarMsg: "",
      timeZones: [],
      timeZone: { name: "", id: 0 },
    };
  }

  // query database for all time zones in dbo.TimeZone
  getTimeZoneTypes = () => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);
    fetch
      .get(`/api/timeZone`)
      .then((response) => {
        if (this._isMounted === true) {
          this.setState({ timeZones: response.data });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getMemberTimeZone = () => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);
    fetch
      .get(`/api/members/${this.props.member.MemberId}/timezone`)
      .then((response) => {
        if (this._isMounted === true) {
          this.setState({
            timeZone: {
              name: response.data.TimeZoneName,
              id: response.data.TimeZoneID,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getEmails = () => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);
    fetch
      .get(`/api/members/${this.props.member.MemberId}/email`)
      .then((response) => {
        if (this._isMounted === true) {
          this.setState({ emails: response.data });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  componentDidMount() {
    this._isMounted = true;
    // Populate time zone dropdown options
    this.getTimeZoneTypes();
    this.getEmails();
    this.getMemberTimeZone();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  handleChanged = (event) => {
    const { member } = this.props;
    member[event.target.name] = event.target.value;
    this.setState({ [event.target.name]: event.target.value });
  };

  handleTimezoneChange = (event) => {
    /** Add New Data to API **/
    let newTz;
    this.state.timeZones.map((tz) => {
      if (tz.TimeZoneName === event.target.value) {
        newTz = tz.TimeZoneID;
      }
    });
    if (newTz) {
      // get user token
      const token = localStorage.getItem("token");
      // get custom axios config
      const fetch = httpr(token); //axios.create()
      // post to api
      fetch
        .post(`/api/members/${this.props.member.MemberId}/timezone`, {
          timeZone: newTz,
        })
        .then((response) => {
          if (response.status === 200) {
            this.setState({
              timeZone: {
                name: response.data.TimeZoneName,
                id: response.data.TimeZoneID,
              },
            });
            this.props.showNotification(AddAlert, "info", "Time Zone Changed");
          } else {
            this.props.showNotification(
              ErrorOutlineIcon,
              "danger",
              "Error changing time zone"
            );
          }
        })
        .catch((err) => {
          console.log("in catch");
          console.log(err);
        });
    }
  };

  handlePhoneClickOpen = () => {
    this.setState({ openPhone: true });
  };

  handlePhoneClose = () => {
    this.setState({ openPhone: false });
  };

  handleEmailClickOpen = () => {
    this.setState({ openEmail: true });
  };

  handleEmailClose = () => {
    this.setState({ openEmail: false });
  };

  handleEmailLocationSelected = (event) => {
    if (event.target.value === "All") {
      this.setState({ emailLocation: "All" });
    } else {
      this.setState({ emailLocation: event.target.value });
    }
  };

  showNotification = (color, msg) => {
    this.setState({
      emailSnackbarOpen: true,
      emailSnackbarMsg: msg,
    });
  };

  handleAddEmail = () => {
    const { member } = this.props;
    const param = {};
    param.Email = this.state.email;
    param.EmailAlert = 1;
    param.LocationId = this.state.emailLocation;

    if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(param.Email) ||
      param.Email.length <= 0
    ) {
      this.setState({ addEmailErr: true });
      this.showNotification("danger", "Please enter a valid email address");
    } else if (param.LocationId === 0) {
      this.setState({ addEmailErr: true });
      this.showNotification("danger", "Please select a location");
    } else {
      // Add email to the MEMBER EMAIL table
      this.props.addAction(`/api/members/${member.MemberId}/email`, param);
    }
  };

  handleAddPhone = () => {
    const { member } = this.props;
    const param = {};
    param.Phone = this.state.phone;
    param.PhoneAlert = 1;

    if (!param.Phone) {
      this.setState({ addPhoneErr: true });
    } else {
      param.Phone = param.Phone.replace(/_/g, "");
      if (param.Phone.length !== 15) {
        this.setState({ addPhoneErr: true });
      } else {
        // Add phone to the MEMBER PHONE table
        this.props.addAction(`/api/members/${member.MemberId}/phone`, param);
      }
    }
  };

  handleSaveUser = (userInfo) => {
    const {
      email,
      confirmEmail,
      password,
      confirmPassword,
      firstName,
      lastName,
      selectedLocIds,
      admin,
    } = this.state;

    let emailErr = false;
    let pwErr = false;
    let fNameErr = false;
    let lNameErr = false;
    let locErr = false;

    if (email.length > 0 || confirmEmail.length > 0) {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
        emailErr = true;
      } else if (email !== confirmEmail) {
        emailErr = true;
      } else {
        userInfo.Email = email;
      }
    }

    if (password.length > 0 || confirmPassword.length > 0) {
      if (password !== confirmPassword) {
        pwErr = true;
      } else {
        userInfo.Password = password;
      }
    }

    if (firstName.length > 0) {
      userInfo.FirstName = firstName;
    }

    if (lastName.length > 0) {
      userInfo.LastName = lastName;
    }

    if (selectedLocIds.length > 0) {
      userInfo.Locations.forEach((loc) => {
        const locIndex = selectedLocIds.indexOf(loc.LocationId);
        if (locIndex < 0) {
          userInfo.Locations.splice(locIndex);
        }
      });
    }

    userInfo.Admin = admin;

    this.setState({
      emailErr,
      pwErr,
      fNameErr,
      lNameErr,
      locErr,
    });

    if (emailErr || pwErr || fNameErr || lNameErr || locErr) {
      return;
    }

    this.props.saveMember(userInfo); // updates LOGIN email in MEMBER table!
  };

  handleToggle = (name) => (event) => {
    const { admin } = this.state;

    this.setState({
      admin: !admin,
    });
  };

  onPhoneInputChange = (val) => (event) => {
    this.setState({ phone: event.target.value });
  };

  onEmailInputChange = (val) => (event) => {
    this.setState({ email: event.target.value });
  };

  onEmailLocationInputChange = (val) => (event) => {
    this.setState({ emailLocation: event.target.value });
  };

  getKey() {
    return Math.floor(Math.random() * 100);
  }

  renderSelectedLocationValues = (event) => {
    const Locations = event;
    const { selectedLocIds } = this.state;
    let locNames = [];

    Locations.map((loc) => {
      if (selectedLocIds.indexOf(loc.LocationId) > -1) {
        locNames.push(loc.LocationName);
      }
    });

    return locNames.join(", ");
  };

  renderEmailLocation = (event) => {
    const { Locations } = this.props;

    return Locations[event].LocationName;
  };

  render() {
    const { classes, member, Locations } = this.props;
    const { timeZones } = this.state;

    const timezoneType = timeZones.map((type) => (
      <MenuItem key={type.TimeZoneID} value={type.TimeZoneName}>
        {type.TimeZoneName.replace("_", " ")}
      </MenuItem>
    ));
    const locationList = Locations.map((location) => (
      <MenuItem key={location.LocationId} value={location.LocationId}>
        <ListItemText primary={location.LocationName.replace(/_/g, " ")} />
      </MenuItem>
    ));

    // format email locations for table
    let memberEmails = this.state.emails;
    memberEmails.map((object, index) => {
      if (object.LocationId === null) {
        memberEmails[index].LocationName = "All";
      } else {
        member.Locations.map((location) => {
          if (location.LocationId === object.LocationId) {
            memberEmails[index].LocationName = location.LocationName.replace(
              /_/g,
              " "
            );
          }
        });
      }
    });

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <Card>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>Info</h4>
              </CardHeader>
              <GridItem xs={12} sm={12} md={12}>
                <p>
                  Name: {member.FirstName} {member.LastName}
                </p>
                <p>Login Email: {member.Email}</p>
              </GridItem>
              <CardFooter>
                <FormHelperText className={classes.helperText}>
                  * Please see the Members page to update this information.
                </FormHelperText>
              </CardFooter>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={12} md={6}>
            <Card>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>Time Zone</h4>
              </CardHeader>
              <FormControl className={classes.helperText}>
                <Tooltip
                  id="timezone-tip"
                  title="Set to the time zone you are in"
                  placement="left"
                >
                  <Select
                    name="selected-timezone"
                    value={this.state.timeZone.name}
                    onChange={this.handleTimezoneChange}
                    input={<Input id="select-timezone" />}
                    MenuProps={MenuProps}
                  >
                    {timezoneType}
                  </Select>
                </Tooltip>
                <FormHelperText>
                  Set time zone for auto alert settings
                </FormHelperText>
              </FormControl>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>Emails</h4>
              </CardHeader>
              <CustomTable
                tableData={memberEmails}
                tableType="Emails"
                deleteAction={this.props.deleteAction}
                addAction={this.props.addAction}
                deleteUrl="/api/members/email/"
                dataUrl={`/api/members/${member.MemberId}/email`}
              />
              <FormHelperText className={classes.helperText}>
                Add email(s) for auto alerts
              </FormHelperText>
              <CardFooter>
                <Tooltip
                  id="add-email-tip"
                  title="Add an email to send notifications for all your locations or just one location"
                  placement="right"
                >
                  <Button color="success" onClick={this.handleEmailClickOpen}>
                    Add Email
                  </Button>
                </Tooltip>
              </CardFooter>
            </Card>
          </GridItem>

          {/*<GridItem xs={12} sm={12} md={6}>
            <Card key={this.getKey()}>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>Phone Numbers</h4>
              </CardHeader>
              <CardBody>
                <p>Phone alerts are coming soon!</p>
              </CardBody>
               <CustomTable
                key={this.getKey()}
                tableData={member.Phones}
                tableType="Phones"
                deleteAction={this.props.deleteAction}
                addAction={this.props.addAction}
                deleteUrl="/api/members/phone/"
                dataUrl={`/api/members/${member.MemberId}/phone`}
              />
              <FormHelperText className={classes.helperText}>
                Add phone number(s) where alerts should be sent.
              </FormHelperText>
              <CardFooter>
                <Button color="success" onClick={this.handlePhoneClickOpen}>
                  Add Phone
                </Button>
              </CardFooter> 
            </Card>
          </GridItem>*/}
        </GridContainer>

        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={this.state.openEmail}
          onClose={this.handleEmailClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.dialogControl}
        >
          <GridItem>
            <Card>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>Add Email</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="Email address"
                      id="email"
                      name="email"
                      error={this.state.addEmailErr}
                      onChange={this.onEmailInputChange("email")}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="select-multiple-checkbox">
                        Select Location
                      </InputLabel>
                      <Select
                        name="selectedLocId"
                        value={this.state.emailLocation}
                        onChange={this.handleEmailLocationSelected}
                        input={<Input id="select-multiple-checkbox" />}
                        MenuProps={MenuProps}
                      >
                        <MenuItem value={"All"}>
                          <ListItemText primary={"All"} />
                        </MenuItem>
                        {locationList}
                      </Select>
                    </FormControl>
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter>
                <Button color="success" onClick={this.handleAddEmail}>
                  Add
                </Button>
                <Button color="transparent" onClick={this.handleEmailClose}>
                  Cancel
                </Button>
              </CardFooter>
            </Card>
          </GridItem>
          <Snackbar
            place="tc"
            color="danger"
            icon={ErrorOutlineIcon}
            message={this.state.emailSnackbarMsg}
            open={this.state.emailSnackbarOpen}
            closeNotification={() =>
              this.setState({ emailSnackbarOpen: false })
            }
            close
          />
        </Dialog>

        <Dialog
          fullWidth={true}
          maxWidth="xs"
          open={this.state.openPhone}
          onClose={this.handlePhoneClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.dialogControl}
        >
          <GridItem>
            <Card>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>Add Phone</h4>
              </CardHeader>
              <CardBody>
                <NumberFormat
                  floatingLabelText="+1 555-555-5555"
                  customInput={CustomInput}
                  format="+1 ###-###-####"
                  mask="_"
                  id="Phone"
                  type="tel"
                  onChange={this.onPhoneInputChange("Phone")}
                  labelText="+1 555-555-5555"
                  name="Phone"
                  error={this.state.addPhoneErr}
                  formControlProps={{
                    fullWidth: true,
                  }}
                />
              </CardBody>
              <CardFooter>
                <Button color="success" onClick={this.handleAddPhone}>
                  Add
                </Button>
              </CardFooter>
            </Card>
          </GridItem>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(Profile);



// WEBPACK FOOTER //
// ./src/components/Members/Profile.jsx